import {
  Component,
  Input,
  Output,
  ViewEncapsulation,
  EventEmitter,
} from "@angular/core";
import { CSVBoxAngularModule } from "@csvbox/angular";
import {
  DataFieldFor,
  DynamicColumn,
} from "../../client-contact-fields/models";
import { CommonModule } from "@angular/common";
import { HotToastService } from "@ngneat/hot-toast";

@Component({
    selector: "csvbox-btn",
    imports: [CSVBoxAngularModule, CommonModule],
    template: `
    <csvbox-button
      [licenseKey]="licenseKey"
      [user]="user"
      [dynamicColumns]="dynamicColumns"
      [imported]="imported.bind(this)"
      [importerReady]="importerReady.bind(this)"
      [onSubmit]="onSubmit.bind(this)"
      class="csvbox-btn"
      [class]="isLoading ? 'component-loading' : 'csvbox-btn'"
    >
      Import
      {{ componentFor === DataFieldFor.Company ? "clients" : "contacts" }}
    </csvbox-button>
  `,
    styles: [
        `
      .csvbox-btn button {
        background-color: #0075ff;
        border-radius: 500px;
        border: none;
        box-shadow: none !important;
        font-size: 1rem;
        font-weight: 700;
        outline: none !important;
        transition: 150ms;
        padding: 6px 16px;
        color: white;
      }
    `,
    ],
    encapsulation: ViewEncapsulation.None
})
export class CsvboxButton {
  constructor(private toastr: HotToastService) {}
  isLoading: boolean = true;
  DataFieldFor = DataFieldFor;
  @Input() dynamicColumns: DynamicColumn[];
  @Input() licenseKey: string;
  @Input() user: Object;
  @Input() componentFor: DataFieldFor;
  @Input() imported: () => void;
  @Output() csvboxSubmit = new EventEmitter<void>();
  importerReady() {
    if (!this.dynamicColumns.length) {
      this.toastr.warning("You don't have any client fields to use for import");
    }
    this.isLoading = !this.isLoading;
  }

  onSubmit() {
    this.csvboxSubmit.emit();
  }
}
